<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/pbN6cz/tc-custom/9780061758393.jpg?1731213955507" alt="This image is the cover for the book Violent Politics"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Violent Politics
      </h1>
      <p class="bookDescription body article font2">
        <p>In the current Middle East, insurgency tactics are used with frequency and increasing success. But guerrilla war-fare is not just the tool of modern-day terrorists. Its roots stretch back to our very own revolution.</p><p>In <i>Violent Politics</i>, William Polk takes us on a concise, brilliant tour of insurgencies throughout history, starting with the American struggle for independence, when fighters had to battle against both the British and the loyalists, those colonists who sided with the monarchy. Instinctively, in a way they probably wouldn't have described as a coherent strategy, the rebel groups employed the tactics of insurgency.</p><p>From there, Polk explores the role of insurgency in several other notable conflicts, including the Spanish guerrilla war against Napoleon, the Irish struggle for independence, the Algerian War of National Independence, and Vietnam. He eventually lands at the present day, where the lessons of this history are needed more than ever as Americans engage in ongoing campaigns in Afghanistan and Iraq—and beyond.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        William R. Polk
      </h2>
      
      <p class="authorDescription body article"><P>William R. Polk taught Middle Eastern history and politics and Arabic at Harvard until 1961, when he became a member of the Policy Planning Council of the U.S. Department of State. In 1965, he became Professor of History at the University of Chicago, where he established the Center for Middle Eastern Studies. His many books include <I>The Birth of America</I> and <I>Understanding Iraq</I>.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HaperCollins
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?cbfebe3a